import { useMutation } from '@tanstack/react-query';
import { showResult } from 'infrastructure/hooks/utils';

import { updatePatientDischargeStatusFn } from './api';
import { useUpdatePatientInfoCache } from '../patient/use-update-patient-info-cache';

interface Props {
  onSuccess: () => void;
}

export const useUpdatePatientDischargeStatus = ({ onSuccess }: Props) => {
  const { updateCache } = useUpdatePatientInfoCache();

  const { mutate, isLoading } = useMutation({
    mutationFn: updatePatientDischargeStatusFn,
    onSuccess(data, variables) {
      updateCache(variables.patientGuid, {
        status: variables.dischargeStatus,
      });
      showResult();
      onSuccess();
    },
  });

  return {
    updateDischargeStatus: mutate,
    updateDischargeStatusLoading: isLoading,
  };
};
